<template>
  <div class="left_block course-statistic">
    <p class="header">
      <router-link :to="'/all-courses'">
        <span class="link"> Все курсы <i style="font-size: 10px;" class="icon-button-arrow"></i> </span>
      </router-link>

      Статистика курса
    </p>

    <CourseStatisticInfo
      @change="loadData" 
      :search="search" 
      :course-info="courseInfo" 
      :stages-list="stagesList"
    />
    <CourseStatisticUsersTable 
      :usersList ="statisticList"
      :currentUserStatistic="currentUserStatistic"
      :currentUserStatisticStage="currentUserStatisticStage"
      :totalCount="totalCount" 
      :search="search"
      @loadUser="loadUser" 
      @changePage="onPageChange"
      @openModal="openProtocolModal"
    />

    <b-modal :active.sync="isProtocolModalShow" has-modal-card scroll="keep">
      <CourseStatisticProtocolModal
        :commissions-list="commissionsList"
        @close-modal="isProtocolModalShow = false"
        @download="download"
        @change-page="commissionPageChange"
        
      />
    </b-modal>
  </div>
</template>

<script>
import CourseStatisticInfo from '@/components/admin/all-courses/CourseStatisticInfo';
import CourseStatisticUsersTable from '@/components/admin/all-courses/CourseStatisticUsersTable';
import CourseStatisticProtocolModal from '@/components/admin/all-courses/CourseStatisticProtocolModal';

export default {
  components: {
    CourseStatisticInfo,
    CourseStatisticUsersTable,
    CourseStatisticProtocolModal,
  },
  data() {
    return {
      search: {
        group_id: null,
        stage_id: null,
        name: null,
        page: 1,
      },
      commissionPage: 1,
      modalBranchId: 0,
      isProtocolModalShow: false,
      userTestAttemptId: null,
    }
  },
  computed: {
    pagesList() {
      const { total } = this.$store.state.courses.courseStatistic
      const pagesCount = Math.ceil(total / 15)
      const result = []
      for (let i = 1; i <= pagesCount; i++) {
        result.push({ id: i, value: `Страница - ${i}` })
      }
      return result
    },
    totalCount(){
      return this.$store.state.courses.courseStatistic.total
    },
    courseId() {
      return Number(this.$route.params.id)
    },
    courseInfo() {
      let statistic = this.$store.state.courses.courseStatistic
      let data = {
        ...this.$store.state.courses.coursePageInfo,
        total: statistic.total,
        passed: statistic.passed,
        not_passed: statistic.not_passed,
      }
      const currentCategory = this.categoriesList.find((el) => el.id === data.category_id)
      if (!currentCategory) {
        return data
      }
      data['category_name'] = currentCategory.name
      return data
    },
    stagesList() {
      return this.$store.state.courses.infoStagesList
    },
    statisticList() {
      return this.$store.state.courses.courseStatistic.data
    },
    categoriesList() {
      return this.$store.state.categories.ModalCategoriesList
    },
    currentUserStatistic(){
      return this.$store.state.courses.currentUserStatistic;
    },
    currentUserStatisticStage(){
      return this.$store.state.courses.currentUserStatisticStage;
    },
    commissionsList() {
      return this.$store.state.branches.commissionsList;
    },
  },
  methods: {
    loadProfile() {
      this.$axios2
        .get('courses/' + this.courseId)
        .then((resp) => {
          this.$store.commit('setCoursePageInfo', { list: resp.data })
        })
        .catch(this.$errorToast)

      this.$axios2
        .get('courses/' + this.courseId + '/stages')
        .then((resp) => {
          this.$store.commit('setInfoStagesList', { list: resp.data })
        })
        .catch(this.$errorToast)
    },
    loadData() {
       this.$axios2
        .get(`courses/statistic/${this.courseId}`, { params: { ...this.search } })
        .then((resp) => {
          this.$store.commit('setCourseStatistic', { list: resp.data })
        })
        .catch(this.$errorToast)
    },
    onPageChange(number) {
      if (!number || number === this.search.page) return;
      this.search.page = number;
      this.loadData();
    },
    loadUser(userId) {
      if (this.search.stage_id) {
        this.loadUserStage(userId)
      } else {
        this.loadUserCourses(userId)
      }
    },
    setCurrentUserStatistic(data, stage = false) {
      data.data = this.loadStatus(data.data)
      this.$store.commit(stage ? 'setCurrentUserStatisticStage' : 'setCurrentUserStatistic', data)
    },
    loadUserCourses(userId) {
      this.$axios2
      .get(`users/${userId}/courses/${this.courseId}`)
      .then((resp) => {
        this.setCurrentUserStatistic(resp.data)
      })
    },
    loadUserStage(userId) {
      this.$axios2
      .get(`users/${userId}/courses/${this.courseId}/stages/${this.search.stage_id}`)
      .then((resp) => {
        this.setCurrentUserStatistic(resp.data, true)
      })
    },
    commissionPageChange(page) {
      this.commissionPage = page;
      this.getCommissionsList(this.modalBranchId);
    },
    getCommissionsList(branch_id) {
      this.isLoading = true;
      return this.$axios2
      .get('commissions?branch_id=' + branch_id + '&page=' + this.commissionPage)
      .then((resp) => {
        const data = {
            total: resp.data.total,
            data: resp.data.data.map((commission) => {
            return {
              ...commission,
              members: JSON.parse(commission.members),
            }
          })
        }
        this.isLoading = false
        return this.$store.commit('setCommissionsList', { list: data })
      })
      .catch(this.$errorToast)
      .finally(() => this.isLoading = false);
    },
    download(commission_id) {
      this.$axios
        .post('protocol', {
          user_test_attempt_id: this.userTestAttemptId,
          commission_id,
        })
        .then((resp) => {
          window.open(resp.data.data.protocol_url)
        })
        .catch(this.$errorToast)
    },
    loadStatus(data) {
      return data.map(element => {
        switch (element.status) {
          case 0:
            element.status = 'Курс начат'
            break;
          case 1:
            element.status = ''
            break;
          case 2:
            element.status = 'Курс пройден'
            break;
          case 3:
            element.status = 'Курс не пройден'
            break;
        }
        return element
      })
    },
    openProtocolModal(branch_id, user_test_attempt_id) {
      this.modalBranchId = branch_id;
      this.userTestAttemptId = user_test_attempt_id;
      this.getCommissionsList(branch_id).then(() => this.isProtocolModalShow = true);
    },
  },
  mounted() {
    this.loadData();
    this.loadProfile();
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === this.$route.name) {
      next();
      this.loadData();
      this.loadProfile();
    }
  },
}
</script>
